import { apiService } from '../../..'
import { stringify } from 'qs'
import { OrderBy, OverduePaymentResponse, PaymentScheduleDueResponse } from '../types'
import { InitiateInstallmentPaymentRequest, InitiateInstallmentPaymentResponse, ConfirmPayNowRequest, ConfirmPayNowResponse } from '..'

export interface GetPaymentSchedulesQuery {
  offset?: number
  limit?: number
  orderBy?: OrderBy
  ascending?: boolean
}

const BASE_URL = '/portal/consumers/paymentschedule'

// @TODO: Some of the names of these querys and mutations are getting confusing, refactor them to make the clearer

export const paymentScheduleService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPaymentSchedule: build.query<PaymentScheduleDueResponse, GetPaymentSchedulesQuery>({
      query: (params) => {
        const defaultParams = { offset: 0, limit: 500, orderBy: OrderBy.DUE_DATE, ascending: true }
        const stringifiedParams = stringify({ ...defaultParams, ...params })
        return {
          url: `${BASE_URL}/due?${stringifiedParams}`,
          method: 'get',
        }
      },
      providesTags: ['PaymentSchedule'],
    }),
    getOverduePayments: build.query<OverduePaymentResponse, void>({
      query: () => {
        return {
          url: `${BASE_URL}/overdue`,
          method: 'get',
        }
      },
      keepUnusedDataFor: 300,
      providesTags: ['OverduePayments'],
    }),
    initiateInstallmentPayment: build.mutation<InitiateInstallmentPaymentResponse, InitiateInstallmentPaymentRequest>({
      query: ({ paymentScheduleIds }) => {
        return {
          url: `${BASE_URL}/paynow/initiate`,
          method: 'POST',
          data: { paymentScheduleIds },
        }
      },
    }),
    confirmPayNow: build.mutation<ConfirmPayNowResponse, ConfirmPayNowRequest>({
      query: ({ paymentMethodType, storeToken, traceId, paymentMethodId }) => {
        return {
          url: `${BASE_URL}/paynow/confirm`,
          method: 'POST',
          data: {
            traceId,
            storeToken,
            paymentMethodType,
            paymentMethodId,
          },
        }
      },
      invalidatesTags: ['PaymentSchedule', 'OverduePayments', 'OrderTransactions', 'CreditLimit', 'AmountDueSummary', 'CreditCards', 'ConsumerAccount'],
    }),
    initiateLendingInstallmentPayment: build.mutation<InitiateInstallmentPaymentResponse, InitiateInstallmentPaymentRequest>({
      query: ({ paymentScheduleIds }) => {
        return {
          url: `${BASE_URL}/paynow/lending/initiate`,
          method: 'POST',
          data: { paymentScheduleIds },
        }
      },
    }),
    confirmLendingPayNow: build.mutation<ConfirmPayNowResponse, ConfirmPayNowRequest>({
      query: ({ paymentMethodType, storeToken, traceId, paymentMethodId }) => {
        return {
          url: `${BASE_URL}/paynow/lending/confirm`,
          method: 'POST',
          data: {
            traceId,
            storeToken,
            paymentMethodType,
            paymentMethodId,
          },
        }
      },
      invalidatesTags: ['PaymentSchedule', 'OverduePayments', 'OrderTransactions', 'AmountDueSummary', 'CreditFacilitySummary'],
    }),
  }),
  overrideExisting: true,
})
